import { UseToastOptions, createStandaloneToast } from '@chakra-ui/react'

import { Toast, ToastProps } from './Toast'

export const defaultToastOptions: ToastProps = {
  position: 'top-right',
  duration: 4000,
  isClosable: true,
  containerStyle: {
    width: '380px',
  },
  render: props => Toast(props),
}

const { toast } = createStandaloneToast({
  defaultOptions: defaultToastOptions as UseToastOptions,
}) as unknown as {
  toast: (options: ToastProps) => ReturnType<typeof createStandaloneToast>
}

export const showToast = toast
